<style>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    overflow-y: auto;
}
.modal-body{
     height: 500px;
    width: 100%;
    overflow-y: auto;
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}
.pac-container {
    z-index: 10000 !important;
}
  .image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
  }
</style>
<template>
    <div class="row">
        <div v-if="showModal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title text-info">
                                        Crear expeciencia
                                    </h4>
                                    <button
                                        type="button"
                                        class="close"
                                        @click="showModal = false"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">

                                   <div class="form-group">
                                        <label>Joven:</label>
                                        {{this.joven.nombres}} {{this.joven.apellido_paterno}} {{this.joven.apellido_materno}}
                                    </div>
                                   
                                     <div class="form-group">
                                        <label>Adjuntar archivo</label>
                                        <input type="file" class="form-control" ref="files" :key="fileInputKey" name="filesArray" multiple @change="onChangeFile">
                                    </div>
                                </div>
                               
                                <div class="modal-footer">
                                    <button
                                        class="btn btn-danger"
                                        @click="cancelarModal()"
                                    >
                                        <i class="fa fa-times"></i>
                                        Cancelar
                                    </button>
                                       <button
                                        class="btn btn-success"
                                        @click="createExperiencia()"
                                    >
                                        <i class="fa fa-check"></i>
                                        Crear Experiencia
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="showModalRueda">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title text-info">
                                        Rueda de la vida
                                    </h4>
                                    <button
                                        type="button"
                                        class="close"
                                        @click="showModal = false"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="form-group">
                                        <label>Dimension:</label>
                                        <v-select v-model="wheel.dimension_id" multiple @input="changeSelect" label="name" :options="dimensiones"></v-select>
                                    </div>
                                    <div class="form-group" v-if="wheel.dimension_id.length>0">
                                        <label><b>Evalue las dimensiones:</b></label>
                                        <div :key="dimension.id" v-for="dimension in wheel.dimension_id">
                                            <label>{{ dimension.name }}</label>
                                            <input
                                                @keyup="evaluarDimension($event, dimension)"
                                                type="number"
                                                :min="0"
                                                :max="7"
                                                class="form-control"
                                            />
                                        </div>
                                    </div>
                                     <div class="form-group">
                                        <label>Observaciones</label>
                                        <textarea
                                            type="text"
                                            class="form-control"
                                            v-model="wheel.comment"
                                        >
                                        </textarea>
                                      
                                    </div>
                            
                                </div>
                               
                                <div class="modal-footer">
                                    <button
                                        class="btn btn-danger"
                                        @click="cancelarModal()"
                                    >
                                        <i class="fa fa-times"></i>
                                        Cancelar
                                    </button>
                                       <button
                                        class="btn btn-success"
                                        @click="createRueda()"
                                    >
                                        <i class="fa fa-check"></i>
                                        Crear Ruerda de la vida
                                    </button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
         <div v-if="showModalObjetivos">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title text-info">
                                        Objetivos pvi
                                    </h4>
                                    <button
                                        type="button"
                                        class="close"
                                        @click="cancelarModal()"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="form-group">
                                        <label>Dimension:</label>
                                        <v-select v-model="objetive.dimension_id" label="name" :options="dimensiones"></v-select>
                                    </div>
                                    <div class="form-group">
                                        <label>Objetivo</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="objetive.purpose"
                                        />
                                    </div>
                                     <div class="form-group">
                                        <label>Termino</label>
                                        <textarea
                                            type="text"
                                            class="form-control"
                                            v-model="objetive.term"
                                        >
                                        </textarea>
                                      
                                    </div>
                                </div>
                               
                                <div class="modal-footer">
                                    <button
                                        class="btn btn-danger"
                                        @click="cancelarModal()"
                                    >
                                        <i class="fa fa-times"></i>
                                        Cancelar
                                    </button>
                                       <button
                                        class="btn btn-success"
                                        @click="createObjetivos()"
                                    >
                                        <i class="fa fa-check"></i>
                                        Crear Objetivo
                                    </button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="showModalSessionWeek">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title text-info">
                                        Sesion semanal PVI
                                    </h4>
                                    <button
                                        type="button"
                                        class="close"
                                        @click="cancelarModal()"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="form-group">
                                        <label>Asiste:</label>
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                <input type="radio" id="asiste" :value="true" v-model="session_week.attend">
                                                Si
                                            </label>
                                            </div>
                                            <div class="form-check">
                                            <label class="form-check-label">
                                                <input type="radio" id="falta" :value="false" v-model="session_week.attend">
                                                No
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="session_week.attend==false">
                                        <label>Justifica inasistencia:</label>
                                         <select class="form-control" v-model="session_week.justify_attend">
                                            <option value="">Seleccione una opcion</option>
                                            <option :value="true">Si</option>
                                            <option :value="false">No</option>
                                            <option value="No aplica">No aplica</option>
                                         </select>
                                    </div>
                                    <div class="form-group" v-if="session_week.justify_attend==true">
                                        <label>Justificacion:</label>
                                         <textarea
                                            type="text"
                                            class="form-control"
                                            v-model="session_week.justify_comment"
                                        >
                                        </textarea>
                                    </div>
                                     <div class="form-group">
                                        <label>Dimension?:</label>
                                        <div class="form-check">
                                            <label class="form-check-label">
                                                 <input type="checkbox" id="checkbox" v-model="session_week.has_dimension">
                                                 {{ session_week.has_dimension == true ? 'Si' : 'No' }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Dimension:</label>
                                        <v-select v-model="session_week.dimension_id" multiple @input="changeSelect" label="name" :options="dimensiones"></v-select>
                                    </div>
                                    <div class="form-group" v-if="session_week.dimension_id.length>0">
                                        <label><b>Evalue las dimensiones:</b></label>
                                        <div :key="dimension.id" v-for="dimension in session_week.dimension_id">
                                            <label>{{ dimension.name }}</label>
                                            <textarea
                                                @keyup="evaluarDimensionWeek($event, dimension)"
                                                type="text"
                                                class="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Observaciones</label>
                                        <textarea
                                            type="text"
                                            class="form-control"
                                            v-model="session_week.comment"
                                        >
                                        </textarea>
                                    </div>
                                </div>
                               
                                <div class="modal-footer">
                                    <button
                                        class="btn btn-danger"
                                        @click="cancelarModal()"
                                    >
                                        <i class="fa fa-times"></i>
                                        Cancelar
                                    </button>
                                       <button
                                        class="btn btn-success"
                                        @click="createSessionWeek()"
                                    >
                                        <i class="fa fa-check"></i>
                                        Crear Sesion Semanal
                                    </button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!--- modal para ver el resumen con la opcion de exportarlo a pdf-->
        <div v-if="showModalResumen">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title text-info">
                                        Resumen pvi {{this.caso.id}}
                                    </h4>
                                    <button
                                        type="button"
                                        class="close"
                                        @click="cancelarModal()"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="form-group">
                                       <label>Fecha:</label> {{this.caso.date}}
                                    </div>
                                     <div class="form-group">
                                      Joven: {{this.caso.joven.nombres}} {{this.caso.joven.apellido_paterno}} {{this.caso.joven.apellido_matero}}
                                    </div>
                                    <h3>Documentos</h3>
                                    <hr>
                                    <div class="form-group" v-if="this.caso.documentos.length>0">
                                        <li :key="item.id" v-for="item in this.caso.documentos">  
                                            {{item.name}}    
                                            <div class="btn-group">                       
                                                <a :href="`/uploadedimages/${item.uri}`" class="btn btn-info text-white" title="Ver adjunto" target="_blank">
                                                    <i class="fa fa-eye">
                                                    </i>
                                                </a>
                                                <a :href="`/uploadedimages/${item.uri}`" :download="item.name" title="Descargar adjunto" class="btn btn-success" target="_blank">
                                                    <i class="fa fa-download">
                                                    </i>
                                                </a>
                                            </div>
                                        </li>
                                    </div>
                                    <div class="form-group" v-else>
                                        <div class="card" >
                                            <div class="card-body bg-danger col-12 text-white text-center">
                                                <b>Sin documentos</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button
                                        class="btn btn-danger"
                                        @click="showModalResumen = false"
                                    >
                                        <i class="fa fa-times"></i>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!-- modal creacion de PVI -->
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <h1>Experiencia</h1>
                    <hr>
                    <div class="form-group text-right">
                        <button
                            class="btn btn-rosa"
                            @click="showModal = true"
                        >
                            <i class="fa fa-plus"></i>
                            Crear Experiencia
                        </button>
                    </div>
                    <div class="form-group">
                        <vue-good-table
                            compactMode
                            :columns="columns"
                            :rows="casos" 
                            :search-options="{
                                enabled: true,
                                placeholder: 'Buscar en la tabla',
                            }" 
                            :pagination-options="{
                                enabled: true,
                                mode: 'records',
                                perPage: 5,
                                perPageDropdown: [3, 7, 9],
                                dropdownAllowAll: true,
                                setCurrentPage: 1,
                                nextLabel: 'siguiente',
                                prevLabel: 'anterior',
                                rowsPerPageLabel: 'Filas por página',
                                ofLabel: 'de',
                                pageLabel: 'página', // for 'pages' mode
                                allLabel: 'Todos',
                            }">
                              <template slot="table-row" slot-scope="props">
                                  <span v-if="props.column.field == 'participantes'">
                                      <ul>
                                         <li :key="item.id" v-for="item in props.row.users">{{item.name}}</li>
                                      </ul>
                                  </span>
                                <span v-if="props.column.field == 'actions'">
                                    <div class="btn-group">                       
                                        <a :href="`/uploadedimages/${props.row.uri}`" class="btn btn-info text-white" title="Ver adjunto" target="_blank">
                                            <i class="fa fa-eye">
                                            </i>
                                        </a>
                                        <a :href="`/uploadedimages/${props.row.uri}`" :download="props.row.name" title="Descargar adjunto" class="btn btn-success" target="_blank">
                                            <i class="fa fa-download">
                                            </i>
                                        </a>
                                    </div>
                                </span>
                                <span v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </span>
                            </template>
                        </vue-good-table>
                        <gallery :images="images" :index="index" @close="index = null"></gallery>
                            <div
                                class="image"
                                v-for="(image, imageIndex) in images"
                                :key="imageIndex"
                                @click="index = imageIndex"
                                :style="{ backgroundImage: 'url(' + image + ')', width: '150px', height: '150px' }"
                            ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueGallery from 'vue-gallery';
import axios from "axios";
import Swal from 'sweetalert2';
import 'vue-select/dist/vue-select.css';
export default {
    props:['propsUsuarios', 'propsDimensiones', 'propsJoven'],
    computed: {},
    components: {
        'gallery':VueGallery
    },
    created() {
        this.usuarios = JSON.parse(this.propsUsuarios);
        this.dimensiones = JSON.parse(this.propsDimensiones);
        console.log("los dimensiones son: ", this.dimensiones);

        this.joven = JSON.parse(this.propsJoven);
        console.log("los usuarios son: ", this.usuarios);
       
        console.log("los jovenes son: ", this.joven);
    },
    async mounted(){
        let names = this.dimensiones.map( e =>  e.name);
        console.log("los scoreDimensions son: ", names);

        await this.getExperiencia();
    },
    data() {
        return {
            fileInputKey:0,
            images:[],
            index: null,
            joven:"",
            scoreDimensions: [],
            experiencia:{
                nnaj_id: ""
            },
            objetive:{
                term:"",
                purpose: "",
                dimension_id: ""
            },
            pvi:{
                id: "",
                time_permancy: 60,
                nnaj_id: "",
                date: ""
            },
            wheel:{
                dimension_id: [],
                scores: [],
                nnaj_id: "",
                comment: "",
                scores:[]
            },
            session_week:{
                attend: true,
                justify_attend: "",
                justify_comment: "",
                has_dimension: false,
                dimension_id: "",
                comment: "",
                scores:[]
            },
            columns: [
                {
                    label: 'Nombre',
                    field: 'name',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'MMM do yy',
                },
                {
                    label: 'Creado en',
                    field: 'created_at',
                    formatFn: this.formatDate,
                },
                {
                    label: 'Acciones',
                    field: 'actions',
                    tdClass: 'text-center text-nowrap',
                    thClass: 'text-center text-nowrap',
                    sortable: false,
            }],
            attachment: [],
            filesArray: null,
            pvi_id:null,
            score: "",
            term: "",
            purpose: "",
            usuarios: [],
            dimensiones: [],
            jovenes: [],
            user_id: "",
            time_permancy:"",
            file_id:"",
            users: [],
            date: "",
            nnaj_id: "",
            dimension_id: "",
            comment: "",
            showModal: false,
            showModalView: false,
            casos: [],
            respuestas: false,
            relato: "",
            hecho: "",
            necesidad: "",
            interes: "",
            emocion: "",
            posicion: "",
            actores: "",
            conflicto: "",
            keyword: "",
            pregunta: "",
            estrategia: "",
            ////
            showRelato: "",
            showHecho: "",
            showNecesidad: "",
            showInteres: "",
            showEmocion: "",
            showPosicion: "",
            showActores: "",
            showConflicto: "",
            showKeyword: "",
            showPregunta: "",
            showEstrategia: "",
            showModalRueda: false,
            showModalObjetivos: false,
            showModalResumen: false,
            showModalSessionWeek: false,
        };
    },
    methods: {
        formatDate(date){
            var date = new Date(date);
            return date.toLocaleString();
        },
        evaluarDimension(event, dimension){
            console.log("el evento es: ", event.target.value);
            console.log("la dimension es: ", dimension);
            let foundedScore = this.wheel.scores.find(e => e.dimension_id === dimension.id);
            if(foundedScore){
                foundedScore.score = event.target.value;
            }else{
                this.wheel.scores.push({ "dimension_id": dimension.id, "score": event.target.value });
            }
            
        },
        evaluarDimensionWeek(event, dimension){
            console.log("el evento es: ", event.target.value);
            console.log("la dimension es: ", dimension);
            let foundedScore = this.session_week.scores.find(e => e.dimension_id === dimension.id);
            if(foundedScore){
                foundedScore.score = event.target.value;
            }else{
                this.session_week.scores.push({ "dimension_id": dimension.id, "score": event.target.value });
            }
            
        },
        changeSelect(valuesSelected){
            
        },
        onChangeFile(event){
            let selectedFiles = event.target.files;
            if(!selectedFiles.length) {
                return false;
            }
            console.log("los selectedFiles son: ", selectedFiles);
            for (let i = 0; i < selectedFiles.length; i++){
                this.attachment.push(selectedFiles[i]);
            }
            console.log("los archivos son: ", this.filesArray);
        },
        getExperiencia() {
            axios
                .get(`/getExperiencia/${this.joven.id}`)
                .then(response => {
                    console.log("la response es: ", response.data);
                    this.casos = response.data.experiences;
                    this.images = response.data.experiences.map(e=>  'https://demo.fundacionsentido.cl/uploadedimages/' + e.uri);
                    console.log("las imageses son: ", this.images);
                })
                .catch(function(error) {
                    // handle error
                    console.log("ocurrio un error: ", error);
                });
        },
        createExperiencia() {       
            let formData = new FormData();
            console.log("el joven es: ", this.joven);
            formData.append('nnaj_id', this.joven.id);
            for (let index = 0; index < this.attachment.length; index++) {
                formData.append('files[]', this.attachment[index]);
            }
            console.log(
                "la data al agregar el la expeicneia es, multipart-2: ",
                formData
            );
            let me = this;
            axios
                .post("/create_experiencia",
                  formData, {
                    headers: {
                        'Content-Type': "multipart/form-data" 
                    }
                            
                })
                .then(function(response) {
                    console.log(
                        "la repsuesta la experiencia  es: ",
                        response
                    );
                    Swal.fire('Experiencia creada creada!', '', 'success');
                    me.cancelarModal();
                    me.getExperiencia();
               
                })
                .catch(function(error) {
                    console.log("FAILURE!!", error);
                });
        },
         createRueda() {
            let data = {
                pvi_id: this.wheel.pvi_id,
                scores: this.wheel.scores,
                comment: this.wheel.comment
            };
            console.log(
                "la data al agregar la rueda es: ",
                data
            );
            let me = this;
            axios
                .post("/create_rueda", data, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(function(response) {
                    console.log(
                        "la repsuesta al agregar el rueda es: ",
                        response
                    );
                    Swal.fire('Rueda pvi creada!', '', 'success')
                    me.showModalRueda = false;
                    me.getExperiencia();
               
                })
                .catch(function(error) {
                    console.log("FAILURE!!", error);
                });
        },
        createObjetivos() {
            let data = {
                pvi_id: this.objetive.pvi_id,
                purpose: this.objetive.purpose,
                dimension_id: this.objetive.dimension_id.id,
                term: this.objetive.term,
            };
            console.log(
                "la data al agregar los objetivos la data  es: ",
                data
            );
            let me = this;
            axios
                .post("/create_objetivos", data, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(function(response) {
                    console.log(
                        "la repsuesta al agregar el rueda es: ",
                        response
                    );
                    Swal.fire('Objetivo pvi creado!', '', 'success')
                    me.showModalObjetivos = false;
                    me.getExperiencia();
               
                })
                .catch(function(error) {
                    console.log("FAILURE!!", error);
                });
        },
        createSessionWeek() {
            let data = {
                attend: this.session_week.attend,
                justify_attend: this.session_week.justify_attend,
                justify_comment: this.session_week.justify_comment,
                scores: this.session_week.has_dimension == true ? this.session_week.scores : null,
                comment: this.session_week.comment,
                pvi_id: this.session_week.pvi_id
            };
            console.log(
                "la data al agregar la sesion semanal es la data  es: ",
                data
            );
            let me = this;
            axios
                .post("/create_session_week", data, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(function(response) {
                    console.log(
                        "la repsuesta al agregar la sesion semanal es: ",
                        response
                    );
                    me.cancelarModal();
                    me.getExperiencia();
                    Swal.fire('Session semanal creada!', '', 'success')
                })
                .catch(function(error) {
                    console.log("FAILURE!!", error);
                });
        },
        verCaso(caso){
            console.log("el caso es: ",caso),
            this.caso = caso;
            this.showModalView = true;
        },
        verRueda(caso){
            console.log("el caso es: ",caso),
            this.caso = caso;
            this.wheel.pvi_id = caso.id;
            this.showModalRueda = true;
        },
         verResumen(caso){
            console.log("el caso es: ",caso),
            this.caso = caso;
            this.showModalResumen = true;
        },
        verObjetivo(caso){
            console.log("el caso es: ",caso),
            this.caso = caso;
            this.objetive.pvi_id = caso.id;
            this.showModalObjetivos = true;
        },
        verSesionSemanal(caso){
            console.log("el caso es: ",caso),
            this.caso = caso;
            this.session_week.pvi_id = caso.id;
            this.showModalSessionWeek = true;
        },
        cancelarModal(){
            this.showModal = false;
            this.showModalRueda = false;
            this.showModalResumen = false;
            this.showModalObjetivos = false;
            this.showModalSessionWeek = false;
            this.objetive = {
                term: "",
                dimension_id: "",
                purpose: ""
            };
            this.pvi = {
                id: "",
                time_permancy: 60,
                nnaj_id: "",
                date: ""
            };
            this.wheel = {
                dimension_id: [],
                nnaj_id: "",
                comment: "",
                scores:[]
            };
            this.session_week = {
                attend: true,
                justify_attend: "",
                justify_comment: "",
                has_dimension: false,
                dimension_id: "",
                comment: "",
                scores:[]
            };
            this.attachment = [],
            this.filesArray =  null;
        },
        eliminarCaso(id){
            let me = this;
            Swal.fire({
                title: '¿Esta seguro de querer borrar el PVI?',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: `Eliminar`,
                cancelButtonText:'Cancelar',
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    axios.delete(`/delete_pvi/${id}`, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                        .then(function(response) {
                            console.log(
                                "la repsuesta al eliminar el institucion es: ",
                                response
                            );
                             Swal.fire('Pvi eliminado!', '', 'success')
                            me.getExperiencia();
                    
                        })
                        .catch(function(error) {
                            console.log("FAILURE!!", error);
                        });
                   
                } else if (result.isDenied) {
                    Swal.fire('Changes are not saved', '', 'info')
                }
                })
        },
    }
};
</script>
